import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import moment from "moment-timezone";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Icon from "../common/icon/icon.component.jsx";
const queryString = require('query-string')

class SchedulingPageBookingThankYou extends Component {

    constructor(props, context) {
        super(props, context)

        let searchQuerySplit = this.props.location.search.split('?')
        let search = `?${searchQuerySplit[1]}&${searchQuerySplit[2]}`
        let searchParams = queryString.parse(search)

        let parentSearchQuerySplit = parent.document.location.href.split('?')
        let parentSearch = `?${parentSearchQuerySplit[1]}`
        let parentSearchParams = queryString.parse(parentSearch)

        this.state = {
            schedulingPageId: this.props.match.params.schedulingPageId,
            searchParams: searchParams,
            parentSearchParams: parentSearchParams
        }
    }

    componentDidMount() {
        let invoiceId = this.state.parentSearchParams["invoiceId"]
        let orderId = this.state.parentSearchParams["orderId"]
        let quoteId = this.state.parentSearchParams["quoteId"]
        let identifier = this.state.searchParams["identifier"]
        let projectId = this.state.searchParams["projectId"]
        let proposalLink = this.state.searchParams["proposalLink"]

        AppContext.getApiClient().post(`/nylas/scheduling-pages/${this.state.schedulingPageId}/events`, {
            invoiceId: invoiceId || "",
            orderId: orderId || "",
            quoteId: quoteId || "",
            identifier: identifier || "",
            projectId: projectId || "",
            proposalLink: proposalLink || "",
            schedulingPageId: this.state.schedulingPageId,
            calendarId: this.state.searchParams["calendar_id"],
            email: Array.isArray(this.state.searchParams["email"]) ? this.state.searchParams["email"][0] : this.state.searchParams["email"],
            eventId: this.state.searchParams["event_id"],
            accountId: this.state.searchParams["accountId"],
            externalAccountId: this.state.searchParams["account_id"],
            timezone: this.state.searchParams["tz"] || moment.tz.guess(),
            editHash: this.state.searchParams["edit_hash"],
            pageSlug: this.state.searchParams["page_slug"],
            bookingId: this.state.searchParams["booking_id"],
            configId: this.state.searchParams["config_id"],
        }).then(res => { })
    }

    render() {
        const sDate = new Date(this.state.searchParams["start_time"] * 1000)
        const eDate = new Date(this.state.searchParams["end_time"] * 1000)
        const email = Array.isArray(this.state.searchParams["email"]) ? this.state.searchParams["email"][0] : this.state.searchParams["email"]
        const fullStartDate = moment(sDate).tz(this.state.searchParams["tz"]).format('dddd, LL')
        const fullEndDate = moment(eDate).tz(this.state.searchParams["tz"]).format('dddd, LL')
        const startDate = moment(sDate).tz(this.state.searchParams["tz"]).format('LL')
        const endDate = moment(eDate).tz(this.state.searchParams["tz"]).format('LL')
        const startTime = moment(sDate).tz(this.state.searchParams["tz"]).format('LT')
        const endTime = moment(eDate).tz(this.state.searchParams["tz"]).format('LT')

        return (
            <div id="schedulingPageBookingThankYou" className="container mt-5 mb-4 text-center">
                <div className="card p-4">
                    <div>
                        <Icon value={'check'} className={'mr-1 fa-3x text-success'} />
                    </div>
                    <h6>
                        <FormattedMessage
                            id="scheduling_page.thank_you"
                            defaultMessage="You successfully scheduled a meeting."
                        />
                    </h6>
                    <h6 className="mb-3">
                        <FormattedMessage
                            id="scheduling_page.thank_you_1"
                            defaultMessage="You will receive an email confirmation at {email}"
                            values={{
                                email: <b>{email}</b>,
                            }}
                        />
                    </h6>

                    <h6 className="mb-0">
                        {this.state.searchParams["location"]}
                        {this.state.parentSearchParams["documentId"]}
                    </h6>
                    {(startDate === endDate) &&
                        [
                            <h5 className="mb-0">
                                {fullStartDate}
                            </h5>,
                            <h5 className="mb-0">
                                {startTime} - {endTime}
                            </h5>]
                    }
                    {(startDate !== endDate) &&
                        <h5 className="mb-0">
                            {fullStartDate} {startTime}
                            <h6 className="mb-0">
                                <FormattedMessage
                                    id="common.to"
                                    defaultMessage="to"
                                />
                            </h6>
                            {fullEndDate} {endTime}
                        </h5>
                    }
                    <div>
                        {this.state.searchParams["tz"]}
                    </div>
                </div>
            </div>
        )
    }

}

export default injectIntl(SchedulingPageBookingThankYou)



// WEBPACK FOOTER //
// ./src/scheduling-page/thankyou.component.jsx